export default __webpack_public_path__ + "static/media/data_saver_red.c76c84a1.svg";